import { createApi } from "@reduxjs/toolkit/query/react";

import { ENV_CONFIG } from "../../config/global.config";
import { AUTH_API_TAGS } from "../app.constants";
import { baseQueryWithReauth } from "./baseQuery";

// --- API ---

export const authServiceApi = createApi({
  reducerPath: "authServiceApi",
  baseQuery: baseQueryWithReauth(ENV_CONFIG.AUTH_API_URL),

  tagTypes: Object.values(AUTH_API_TAGS),
  keepUnusedDataFor: 10,
  endpoints: () => ({}),
});
